module.exports = __webpack_public_path__ + "img/logo.8a20f2c9.jpg";